module.exports = __webpack_public_path__ + "media/images/icons/facebook_circle-7925561ab330abc53434c41c5fe9ad23.svg";